// Shared "learner view" — Nursing Student vs NP Student. Persisted in
// localStorage so the toggle carries across every page.
import { useCallback, useEffect, useState } from "react";

const KEY = "maldek_view_v1";

export const VIEWS = [
  { id: "nursing", label: "Nursing Student", short: "Nursing", accent: "#6B8F71" },
  { id: "np", label: "Nurse Practitioner Student", short: "NP", accent: "#6B8F71" },
];

export function getView() {
  try { return localStorage.getItem(KEY) === "np" ? "np" : "nursing"; }
  catch { return "nursing"; }
}

export function useView() {
  const [view, setViewState] = useState(getView);
  useEffect(() => {
    const h = () => setViewState(getView());
    window.addEventListener("maldek-view", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("maldek-view", h);
      window.removeEventListener("storage", h);
    };
  }, []);
  const setView = useCallback((v) => {
    try { localStorage.setItem(KEY, v === "np" ? "np" : "nursing"); } catch { /* ignore */ }
    setViewState(v === "np" ? "np" : "nursing");
    window.dispatchEvent(new Event("maldek-view"));
  }, []);
  return [view, setView];
}

export const viewMeta = (id) => VIEWS.find((v) => v.id === id) || VIEWS[0];
